//C:\xampp\htdocs\pms2\frontend\src\hooks\usePaymentStatus.ts
/*import { useEffect, useState } from "react";
import api from "../services/api";

export type PaymentStatus = "pending" | "paid" | "failed" | "expired";

export function usePaymentStatus(saleId: number | null) {
  const [status, setStatus] = useState<PaymentStatus>("pending");

  useEffect(() => {
    if (!saleId) return;

    let cancelled = false;

    const poll = async () => {
      try {
        const res = await api.get(`/sales/${saleId}`);

        if (cancelled) return;

        setStatus(res.data.status);

        // ✅ Use is_final flag from backend
        if (!res.data.is_final) {
          setTimeout(poll, 5000);
        }
      } catch (e) {
        console.error("Polling failed", e);
        setTimeout(poll, 10000); // slower retry on error
      }
    };

    poll();

    return () => {
      cancelled = true;
    };
  }, [saleId]);

  return status;
}


export function usePaymentStatus(saleId: number | null) {
  const [status, setStatus] = useState<PaymentStatus>("pending");

  useEffect(() => {
    if (!saleId) return;

    let active = true;
    let timeout: NodeJS.Timeout;

    const poll = async () => {
      try {
        const res = await api.get(`/sales/${saleId}`);

        if (!active) return;

        setStatus(res.data.status);

        if (!res.data.is_final) {
          timeout = setTimeout(poll, 5000);
        }
      } catch (e) {
        if (!active) return;
        timeout = setTimeout(poll, 10000);
      }
    };

    poll();

    return () => {
      active = false;
      if (timeout) clearTimeout(timeout);
    };
  }, [saleId]);

  return status;
}
*/
import { useEffect, useState } from "react";
import api from "../services/api";

export type PaymentStatus = "pending" | "paid" | "failed" | "expired";

const MAX_RETRIES = 10;
const NORMAL_INTERVAL = 5000;
const ERROR_INTERVAL = 10000;

export function usePaymentStatus(saleId: number | null) {
  const [status, setStatus] = useState<PaymentStatus>("pending");

  useEffect(() => {
    if (!saleId) return;

    let active = true;
    let retries = 0;
    let timeout: ReturnType<typeof setTimeout> | null = null;

    const poll = async () => {
      if (!active) return;
      if (retries >= MAX_RETRIES) return;

      try {
        const res = await api.get(`/sales/${saleId}`);

        if (!active) return;

        setStatus(res.data.status as PaymentStatus);

        if (!res.data.is_final) {
          timeout = setTimeout(poll, NORMAL_INTERVAL);
        }
      } catch (err) {
        retries++;

        if (!active) return;

        timeout = setTimeout(poll, ERROR_INTERVAL);
      }
    };

    poll();

    return () => {
      active = false;
      if (timeout) clearTimeout(timeout);
    };
  }, [saleId]);

  return status;
}


